import { useEffect } from 'react';
import useCurrentUser from 'web-ssr/app/common/hooks/useCurrentUser';

/**
 * 🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨
 * ## READ THIS BEFORE ADDING TO THIS FILE
 * Before you make changes to what type of
 * data you pass to GTM, double check that this
 * data does not break GDPR regulations. Under no
 * circumstances
 * ----------------AT ALL-----------------------
 * should you be passing PI like name, email, etc
 *
 * ## What is acceptable?
 * Zapier proprietary information such as account
 * plan, user ids, trial information, etc is ok.
 *
 * We can get into a lot of hot water with any
 * simple violation here, so PLEASE be careful
 * 🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨🚨
 */

export function GoogleTagManager() {
  const { currentUser } = useCurrentUser();
  const { isTrialingCompanies, companiesTrialEndDate } = currentUser;

  useEffect(() => {
    if (process.browser && window && window.dataLayer) {
      const hasUpdatedPersonalInfo = (window.dataLayer || []).find(
        data => data.event === 'updateAccountData'
      );
      if (!hasUpdatedPersonalInfo) {
        window.dataLayer.push({
          event: 'updateAccountData',
          companiesTrialEndDate: companiesTrialEndDate || false,
          isTrialingCompanies,
        });
      }
    }
  }, [isTrialingCompanies, companiesTrialEndDate]);
  return null;
}
